module.exports = __webpack_public_path__ + "img/vip-img1.e4e399f7.png";